import { render, staticRenderFns } from "./SalonDetalle.vue?vue&type=template&id=55c76a40&"
import script from "./SalonDetalle.vue?vue&type=script&lang=js&"
export * from "./SalonDetalle.vue?vue&type=script&lang=js&"
import style0 from "./SalonDetalle.vue?vue&type=style&index=0&id=55c76a40&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports